import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';

import config from 'client/shared/config';

import EditOptionsButton from './edit-options-button';

@observer
class ItemOptions extends React.Component {
	constructor(props) {
		super(props);
		this.state = {active: false, lastTarget: null}
	}
    render () {
		const { genre, optionType, optionIcon, optionsTheme = 'light', rollover='true'} = this.props;


		return (
			<div style={{position:"relative"}}>
			<EditOptionsButton
                id="EDITOPTIONSBUTTON"
				menuOnLeft
				optionIcon={optionIcon}
				onClick={(e) => this.onClick(e) }
				onBlur={(e) => this.onBlur(e) }
				className={ `list-options newreleases active left ${ optionsTheme }` }
			>
			</EditOptionsButton>
                {this.state.active && optionType === 'create' && this.renderCreateOptions(genre)}
                {this.state.active && optionType === 'edit' && this.renderEditOptions(genre, '')}
			</div>
		);
    }

    renderCreateOptions(genre) {
		return (
			<div style={{position: 'absolute', width: '10vw', zIndex: 10}}>
				<div className="cell auto list-options-menu admin popup-menu">
				<ul style={{ listStyleType: 'none', marginLeft: '0.9vw'}}>
					<li className="list-options-parent">
						<NavLink
							to={{ 
								pathname: `/list-editor/CREATE_NEW`,
								data: {
									listType: "ARTIST", 
									listId: false,
									genre: genre,
									showOnFrontPage: false,
									returnURL: "#/manage-genres"
								}
							}}
						>
							Create Artist List
						</NavLink>
					</li>
					<li className="list-options-parent">
						<NavLink
							to={{ 
								pathname: `/list-editor/CREATE_NEW`,
								data: {
									listType: "ALBUM", 
									listId: false,
									genre: genre,
									showOnFrontPage: false,
									returnURL: "#/manage-genres"
								}
							}}
						>
							Create Album List
						</NavLink>
					</li>
					<li className="list-options-parent">
						<NavLink
							to={{ 
								pathname: `/list-editor/CREATE_NEW`,
								data: {
									listType: "SAMPLEPACK", 
									listId: false,
									genre: genre,
									showOnFrontPage: false,
									returnURL: "#/manage-genres"
								}
							}}
						>
							Create Sample Pack
						</NavLink>
					</li>
				</ul>
				
					
					
				</div>
			</div>
		);
	}

    renderEditOptions(genre, id) {
		return (
			<div style={{position: 'absolute', width: '10vw', zIndex: 10}}>
				<div className="cell auto list-options-menu admin popup-menu">
				<ul style={{ listStyleType: 'none', marginLeft: '0.9vw'}}>
					<li className="list-options-parent">
						<NavLink
							to={{ 
								pathname: `/list-editor/CREATE_NEW`,
								data: {
									listType: "ARTIST", 
									listId: id,
									genre: genre,
									showOnFrontPage: false,
									returnURL: "#/manage-genres"
								}
							}}
						>
							Edit Artist List
						</NavLink>
					</li>
					<li className="list-options-parent">
						<NavLink
							to={{ 
								pathname: `/list-editor/CREATE_NEW`,
								data: {
									listType: "ALBUM", 
									listId: id,
									genre: genre,
									showOnFrontPage: false,
									returnURL: "#/manage-genres"
								}
							}}
						>
							Edit Album List
						</NavLink>
					</li>
					<li className="list-options-parent">
						<NavLink
							to={{ 
								pathname: `/list-editor/CREATE_NEW`,
								data: {
									listType: "SAMPLEPACK", 
									listId: id,
									genre: genre,
									showOnFrontPage: false,
									returnURL: "#/manage-genres"
								}
							}}
						>
							Edit Sample Pack
						</NavLink>
					</li>
				</ul>
				
					
					
				</div>
			</div>
		);
	}

	@autobind
	renderOptionsButton ({ icon, position, onClick, label, attrs = {} }) {
		return (
			<div key={ position }>
				<button
					{ ...attrs }
					onClick={ onClick }
					className="button tertiary clear margin-bottom-0">
						<span className={ `${icon} icon` }></span> { label }
				</button>
			</div>
		);
	}

	@autobind
	onClick (evt) {
		evt.preventDefault();
		this.setState({active: true});
	}

	@autobind
	onBlur (evt) {
		evt.preventDefault();
		console.log(evt.relatedTarget)
		console.log(evt.target)
		console.log(evt.currentTarget)
		if(evt.relatedTarget !== this.state.lastTarget) {
			this.setState({lastTarget: evt.relatedTarget});
		}
		if(evt.relatedTarget === null) {
			this.setState({active: false, lastTarget: evt.relatedTarget});
		}
	}
}
export default ItemOptions;
